import React from "react";
import PropTypes from "prop-types";

import {Box, Fab, Typography} from "@mui/material";

import AddIcon from '@mui/icons-material/Add';

const NoRules = props => {
    const {onCreate} = props;

    return (
        <Box sx={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative"
        }}>
            <Typography variant="subtitle1">
                <Box sx={{fontWeight: "light"}}>
                    NON CI SONO FILTRI
                </Box>
            </Typography>
            <Fab size="medium"
                 variant="extended"
                 aria-label="Crea nuovo"
                 color='primary'
                 onClick={onCreate}
                 sx={{position: 'absolute', bottom: 0, right: 0,}}>
                <AddIcon/>
                Crea
            </Fab>
        </Box>
    )
};

NoRules.propTypes = {
    onCreate: PropTypes.func.isRequired,
};

export {NoRules}